import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import InputMask from 'react-input-mask';

import { FieldCustom } from '../FieldCutom';

import styles from './PhoneField.module.sass';

const PhoneField: FC = () => {
  const {
    getValues,
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <Controller
      control={control}
      name="phone"
      defaultValue=""
      rules={{
        required: 'Номер телефона обязателен',
        validate: {
          required: (value) =>
            (value && value.length >= 13) || 'Некорректный формат телефона',
        },
      }}
      render={({ field: { onChange, value } }) => {
        return (
          <div className={styles.wrapper}>
            <div className={styles.custom}>
              <div className={styles.number}>+7</div>
              <div></div>
            </div>
            <InputMask
              mask="999 999 99 99"
              maskChar={null}
              maskPlaceholder={null}
              value={value}
              onChange={onChange}
              inputMode="tel"
              width={100}
            >
              <div>
                <FieldCustom
                  className={styles.field}
                  label="Введите номер телефона"
                  name="phone"
                  variant="standard"
                  defaultValue={getValues('phone')}
                />
                {errors && errors.phone && errors.phone.message && (
                  <div
                    className={styles.error}
                  >{`${errors.phone.message}`}</div>
                )}
              </div>
            </InputMask>
          </div>
        );
      }}
    />
  );
};

export default PhoneField;
